// extracted by mini-css-extract-plugin
export var closeButton = "infoBanner-module--close-button--U9bnc";
export var infoBannerWrapper = "infoBanner-module--info-banner-wrapper--xNUt9";
export var infoText = "infoBanner-module--info-text--7LwR7";